import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { type JudicialRecord } from '@/components/model'
import { AdminHeader } from '@/components/organisms/AdminHeader'
import { cn } from '@/lib/utils'

import { volunteerPiloteUrl } from '../../utils/volunteerPiloteUrl'

export interface PlumitifViewProps {
  record: JudicialRecord
  text: string
  asIframe?: boolean
}

export const PlumitifView: FC<PlumitifViewProps> = ({ record, text, asIframe }) => {
  const intl = useIntl()

  return (
    <div className={cn('flex h-full flex-col')}>
      <AdminHeader />

      <div className="flex h-[calc(100vh-6rem)] flex-col pl-10">
        <div className="mb-4 flex items-baseline gap-4 p-6">
          <h1 className="text-xl font-normal text-gray-800 select-none">
            {intl.formatMessage({ id: 'judicial.results.pageTitle' })}
          </h1>
          <p className="text-sm">
            <a href={volunteerPiloteUrl(record)} target="_blank" className="text-blue-700 underline" rel="noreferrer">
              {record.volunteer.code}
            </a>
          </p>
          <p className="text-sm">
            {record.volunteer.lastName}, {record.volunteer.firstName}
          </p>
          <p className="text-sm">{record.volunteer.birthDate}</p>
        </div>

        <div className="flex flex-1 overflow-hidden overflow-y-auto">
          {asIframe ? <iframe srcDoc={text} className="h-full w-full border-0" /> : <pre>{text}</pre>}
        </div>
      </div>
    </div>
  )
}
